import React, { ReactElement } from "react";
import { BiHelpCircle } from "react-icons/bi";
import {
    BsFillGearFill,
    BsHandThumbsUp,
    BsShopWindow, BsShuffle,
} from "react-icons/bs";
import { FaUsers, FaWpforms } from "react-icons/fa";
import { IoTimeOutline } from "react-icons/io5";
import Help, { ARTICLES } from "../../../../components/help/Help";
import SquareIcon from "../../../../components/square-icon/SquareIcon";
import { NavLink, Paths } from "../../../../contexts/Routing";
import useLogging from "../../../../contexts/logging/LoggingContext";

const STEPS = [
    {
        id: "users",
        setting: "users",
        icon: <FaUsers />,
        title: "Set up Users",
        description: "Add more agents or administrators.",

    },
    {
        id: "request-types",
        setting: "request-types",
        icon: <FaWpforms />,
        title: "Request Types",
        description: "Configure the types of requests users can create.",
    },
    {
        id: "time",
        setting: "time",
        icon: <IoTimeOutline />,
        title: "Set up off-hours",
        description: "Set up off-hours and display a message when you are away.",

    },
    {
        id: "feedback",
        setting: "feedback",
        icon: <BsHandThumbsUp />,
        title: "Set up Feedback",
        description: "Set the integrated Feedback.",

    },
    {
        id: "queues",
        setting: "queues",
        icon: <BsShuffle />,
        title: "Set up Queues",
        description: "Configure queues which manage ticket routing.",

    },
    {
        id: "services",
        setting: "workflow-services",
        icon: <BsShopWindow />,
        title: "Integrations",
        description: "Configure integrations with your standard tools.",
    },

];
export default function Home(): ReactElement {
    const logging = useLogging();
    return (
        <div className="full-page">
            <div className="centered-container centered-container-lg pt-5 align-items-start">

                <h4 className="px-2 w-100 mb-2">
                    <BsFillGearFill />
                    {" "}
                    Settings
                </h4>
                <p className="px-2 text-light  mb-2">
                    These are some of the more common settings you may want to change.
                    However, you can view all settings by clicking through the categories on the left.
                </p>

                <div className="list-group list-group-horizontal w-100 flex-wrap">
                    {STEPS.map(step => (
                        <div className="col-6 col-lg-4 p-2" key={step.id}>
                            <NavLink
                                to={Paths.ADMINISTRATOR_SETTING}
                                params={{ setting: step.setting }}
                                className="list-group-item p-3 rounded hover-shadow mx-auto h-100 text-gray-800"
                                onClick={() => logging.debug({ step: step.id }, "User clicked settings home step")}
                            >
                                <div className="mb-2">
                                    <SquareIcon className="me-2">
                                        {step.icon}
                                    </SquareIcon>
                                    <strong>{step.title}</strong>
                                </div>
                                <p>
                                    {step.description}
                                </p>
                            </NavLink>
                        </div>
                    ))}

                </div>
                <div className="text-end w-100">
                    <Help
                        articleId={ARTICLES.SETTINGS_HOME}
                        buttonClassName="btn btn-none text-light"
                        button={(
                            <span>
                                <BiHelpCircle />
                                {" "}
                                Help
                            </span>
                        )}
                    />
                </div>

            </div>

        </div>
    );
}
